import { useSyncExternalStore } from 'react'

/**
 * Whether this device shows the Teilnehmersicht (the reception-device
 * attendance signing) instead of the staff app, and how often a wrong code
 * was typed since the coach last unlocked it. Kept in this browser so a
 * reload lands in the Teilnehmersicht again; only the coach's password
 * leaves it.
 */
export type Teilnehmersicht = { aktiv: boolean; fehlversuche: number }

export const MAX_FEHLVERSUCHE = 3

const KEY = 'admination.teilnehmersicht'
const RUHE: Teilnehmersicht = { aktiv: false, fehlversuche: 0 }
const listeners = new Set<() => void>()
let stand: Teilnehmersicht = lesen()

function lesen(): Teilnehmersicht {
  try {
    const raw = localStorage.getItem(KEY)
    if (!raw) return RUHE
    const parsed: unknown = JSON.parse(raw)
    if (!parsed || typeof parsed !== 'object') return RUHE
    const { aktiv, fehlversuche } = parsed as Record<string, unknown>
    return { aktiv: aktiv === true, fehlversuche: typeof fehlversuche === 'number' ? fehlversuche : 0 }
  } catch {
    // No browser storage: the Teilnehmersicht then does not survive a reload.
    return RUHE
  }
}

function schreiben(next: Teilnehmersicht): void {
  stand = next
  try {
    if (next.aktiv) localStorage.setItem(KEY, JSON.stringify(next))
    else localStorage.removeItem(KEY)
  } catch {
    // No browser storage: the Teilnehmersicht then does not survive a reload.
  }
  for (const listener of listeners) listener()
}

export function teilnehmersichtStarten(): void {
  schreiben({ aktiv: true, fehlversuche: 0 })
}

export function teilnehmersichtBeenden(): void {
  schreiben(RUHE)
}

export function fehlversuchZaehlen(): void {
  schreiben({ aktiv: true, fehlversuche: stand.fehlversuche + 1 })
}

export function entsperren(): void {
  schreiben({ aktiv: true, fehlversuche: 0 })
}

export function useTeilnehmersicht(): Teilnehmersicht {
  return useSyncExternalStore(
    (listener) => {
      listeners.add(listener)
      return () => listeners.delete(listener)
    },
    () => stand,
  )
}
